// extracted by mini-css-extract-plugin
export default {"status":"investigation-status_status__wYH-h","open":"investigation-status_open__9hjvq","closed":"investigation-status_closed__1woL6"};